import { render } from "./Specs.vue?vue&type=template&id=310558a2"
import script from "./Specs.vue?vue&type=script&lang=js"
export * from "./Specs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__